import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReviewResponseService } from '../services/review-response.service';
var EditReviewResponseComponent = /** @class */ (function () {
    function EditReviewResponseComponent(_matDialogRef, data, _responseService) {
        this._matDialogRef = _matDialogRef;
        this._responseService = _responseService;
        this.isAirport = false;
        this.entityId = data.entityId;
        this.reviewId = data.reviewId;
        this.isAirport = data.isAirport;
        this.selectedResponse = data.response;
    }
    EditReviewResponseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            responseText: new FormControl(this.selectedResponse, [Validators.maxLength(2000)])
        });
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditReviewResponseComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        res = void 0;
                        return [4 /*yield*/, this._responseService.putReviewResponse(this.entityId, this.isAirport, this.reviewId, this.selectedResponse)];
                    case 1:
                        res = _a.sent();
                        this.close({ cancelBtnClicked: false, success: true });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditReviewResponseComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditReviewResponseComponent.prototype.close = function (data) {
        this._matDialogRef.close(data);
    };
    return EditReviewResponseComponent;
}());
export { EditReviewResponseComponent };
